import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";

/**
 * Light/dark toggle. Mantine v7's `colorScheme` value is one of
 * 'light' | 'dark' | 'auto'. With `defaultColorScheme="auto"` the initial
 * value is the literal `"auto"` until the user clicks. To decide which
 * ICON to show we read `useComputedColorScheme()` (resolves "auto" against
 * the system pref). Clicking cycles light↔dark and always stores the
 * explicit choice, so the no-flash inline script in index.html can read
 * a concrete value on the next page load.
 */
export function ThemeToggle({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light");
  const isDark = computedColorScheme === "dark";
  const next = isDark ? "light" : "dark";
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      size={size}
      onClick={() => setColorScheme(next)}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? <IconSun size={18} /> : <IconMoon size={18} />}
    </ActionIcon>
  );
}
